import axios from "axios"
import { AppConfig } from "../AppConfig";

const instance = axios.create({
    baseURL: AppConfig.apiUrl,
    headers: {'Access-Control-Allow-Origin': 'privatekey'}
});

instance.interceptors.request.use((req => {
  const token = localStorage.getItem('token');
  req.headers.Authorization = token ? `Bearer ${token}` : ''
  
  return req
})); 

export default instance;